module.exports = __webpack_public_path__ + "img/HC1015-115.dc92fab3.jpg";